var _polyline, _path, _path2, _g, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveColorChange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "38.47 12.04 37.07 16.87 32.25 15.46",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.93,16.87c.69-1.7,1.72-3.29,3.1-4.67,1.38-1.38,2.97-2.41,4.67-3.1s3.5-1.03,5.31-1.03,3.61.34,5.31,1.03,3.29,1.72,4.67,3.1,2.41,2.97,3.1,4.67",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34,27.34c-1.85,0-3.34-1.49-3.34-3.34s1.49-3.34,3.34-3.34,3.34,1.49,3.34,3.34-1.49,3.34-3.34,3.34Z",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled_section"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.66,27.34c-1.85,0-3.34-1.49-3.34-3.34s1.49-3.34,3.34-3.34,3.34,1.49,3.34,3.34-1.49,3.34-3.34,3.34Z",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.76,24.97l1.33,1.67s-5.6,7.42-13.13,9.58c4.07-5.88,11.8-11.24,11.8-11.24Z",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.89,20.12s1.07,2.33.05,4.35c-1.45,2.87-3.85,2.17-3.85,2.17l-1.33-1.67s-.17-2.43,2.17-2.88c1.36-.26,2.96-1.98,2.96-1.98Z",
    fill: "#fbba00",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveColorChange);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-color-change.a03552c725d3cf4668329b42037ba81c.svg";
export { ForwardRef as ReactComponent };